import api from "utils/axios";

export async function getAllTickets(page, limit) {
    try {
        const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/support/get-all-tickets`, {
            params: { page, limit }
        });
    
        if (!data || !data.success) {
          throw new Error(data.message || "Failed to fetch tickets");
        }
    
        return {
          success: true,
          data: data.data,
        };
      } catch (error) {
        console.error("Error getting tickets:", error);
        return {
          success: false,
          message: "Failed to load settings"
        }
      }
}

export async function getAllChats(page = 1, limit = 10) {
    try {
        const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/support/get-all-chats`, {
            params: { page, limit }
        });
    
        if (!data || !data.success) {
          throw new Error(data.message || "Failed to fetch chats");
        }
    
        return {
          success: true,
          data: data.data,
          pagination: data.pagination,
        };
      } catch (error) {
        console.error("Error getting chats:", error);
        return {
          success: false,
          message: "Failed to load chats"
        }
      }
}

export async function deleteChat(userId) {
    try {
        const { data } = await api.delete(`${process.env.REACT_APP_BASE_URL}/support/delete-chat`, {
            params: { userId }
        });
    
        if (!data || !data.success) {
          throw new Error(data.message || "Failed to delete chat");
        }
    
        return {
          success: true,
          message: "Chat deleted successfully",
        };
      } catch (error) {
        console.error("Error deleting chat:", error);
        return {
          success: false,
          message: "Failed to delete chat",
        };
      }
}


export async function getMessages(userId, page = 1, limit = 20) {
    try {
        const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/support/get-messages`, {
            params: { userId, page, limit }
        });

        if (!data || !data.success) {
            throw new Error(data.message || "Failed to fetch messages");
        }

        return {
            success: true,
            data: data.data,
        };
    } catch (error) {
        console.error("Error getting messages:", error);
        return {
            success: false,
            message: "Failed to load messages"
        };
    }
}

export async function getChats(page = 1, limit = 10) {
    try {
        const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/support/get-chats`, {
            params: { page, limit }
        });

        if (!data || !data.success) {
            throw new Error(data.message || "Failed to fetch chats");
        }

        return {
            success: true,
            data: data.data,
        };
    } catch (error) {
        console.error("Error getting chats:", error);
        return {
            success: false,
            message: "Failed to load chats"
        };
    }
}

export async function changeTicketStatus(ticketId, status) {
    try {
        const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/support/change-ticket-status`, {
            ticketId,
            status
        });

        if (!data || !data.success) {
            throw new Error(data.message || "Failed to change ticket status");
        }

        return {
            success: true,
            data: data.data,
        };
    } catch (error) {
        console.error("Error changing ticket status:", error);
        return {
            success: false,
            message: "Failed to change ticket status"
        };
    }
}